import {

  CORE_LOAD_ALLZONE_REQUEST,
  CORE_LOAD_ALLZONE_SUCCESS,

  CORE_LOAD_ZONEINFO_REQUEST,
  CORE_LOAD_ZONEINFO_SUCCESS,

  CORE_SEARCH_ZONE_REQUEST,
  CORE_SEARCH_ZONE_SUCCESS,

} from '../../../types'

const initialState = []
export default {
  zone: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALLZONE_REQUEST:
      case CORE_SEARCH_ZONE_REQUEST:
        return initialState

      case CORE_LOAD_ALLZONE_SUCCESS:
      case CORE_SEARCH_ZONE_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
  zoneInfo: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ZONEINFO_REQUEST:
        return {}
      case CORE_LOAD_ZONEINFO_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
}


// WEBPACK FOOTER //
// ./src/features/location/zone/reducer.js